import * as React from 'react';
import { Button, SxProps } from '@mui/material';
import { FaOptionIcon, FaOptionIconProps, NamedIconsType } from '@europrocurement/l2d-icons';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';

export type ActionButtonProps = {
    action: () => void;
    icon?: NamedIconsType;
    label: string | React.ReactNode;
    disabled?: boolean;
    sx?: SxProps;
};

/** Action button used in Listing & preview layout */
export const ActionButton: React.FunctionComponent<ActionButtonProps> = function ({
    action,
    icon,
    label,
    disabled = false,
    sx,
}) {
    const listingActionButtonStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 0 15px 15px',
        maxHeight: '60px',
        width: '16%',
        borderRadius: '15px',
        ...sx,
    };

    let iconProps: undefined | FaOptionIconProps;
    if (icon) {
        iconProps = {
            ...icon.props,
            sx: {
                ...icon?.props?.sx,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0px 10px',
                color: 'inherit',
            },
        };
    }

    return (
        <Button
            variant="contained"
            onClick={() => {
                action();
            }}
            disabled={disabled}
            sx={sx ?? listingActionButtonStyle}
        >
            {icon && iconProps ? (
                <FaOptionIcon
                    {...iconProps}
                    icon={['fasl', (icon.props.icon as unknown as IconLookup).iconName]}
                />
            ) : null}
            {label}
        </Button>
    );
};
